// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    API_URL: 'https://api.afrotech-hub.com/api',
    API_TOKEN: '6bb4591ba2a2f37634c4870384548ae38429138d7af88afb4918cdad9af51049fb504167166b46cc2362b8742151c4eccee646a66e6fe3a2eb14fea3579e7e585136d526b6817e2acc15425e1152e4e18c26f3cd107dbe014a2dec18654676ad59fcef80140c5507501efdb484698ef6544bffaa1abe2c3444aeaba36c97c460',
    WEBSITE_URL: 'localhost',
    N8N_LINK: 'https://83879a6e9b5b.ngrok-free.app/webhook/826b3e04-3d0d-40e2-ae43-1fba910a507b/chat',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.